<template>
    <div class="discuss-hot-list">
        <virtual-list
            ref="vsl"
            v-show="!!secondLunpanList.length"
            id="DiscussSecondVirtualList"
            class="overflow-y-scroll scroll-touch"
            :data-key="'id'"
            :data-sources="secondLunpanList"
            :data-component="itemComponent"

            :estimate-size="50"
            :item-class="'com-record-item-w90'"
            :footer-class="'famous-list-note'"
            v-on:tobottom="onScrollToBottom">
            <div v-show="parseInt(secondLunpanTotalData.nowpage) < parseInt(secondLunpanTotalData.totalpage)" slot="footer" class="lds-dual-ring lds-dual-ring-gray"></div>
        </virtual-list>
    </div>
</template>

<script>
import DiscussMainItem from '../../components/discuss/DiscussMainItem.vue'
import DiscussDeleteItem from '../../components/discuss/DiscussDeleteItem.vue'
export default {
    name: 'DiscussSecondVirtualList',
    computed: {
        secondLunpanTab() {
            return this.$store.state.discuss.secondLunpanTab;
        },
        secondLunpanList() {
            return this.$store.state.discuss.secondLunpanList;
        },
        secondLunpanTotalData() {
            return this.$store.state.discuss.secondLunpanTotalData;
        }
    },
    data() {
        return {
            itemComponent: DiscussMainItem,
        }
    },
    mounted() {
        this.$bus.on('updateDiscussSecondListDom', this.initDom);
    },
    destroyed() {
        this.$bus.off('updateDiscussSecondListDom', this.initDom);
    },
    methods: {
        initDom() {
            var titleDom = document.getElementsByClassName('discuss-second-title-bar')[0],
                listDom = document.getElementsByClassName('discuss-second-list')[0];
            var height = titleDom ? innerHeight-titleDom.clientHeight : innerHeight;
            this.$el.style.height = height+'px';
            if(listDom) {
                listDom.style.paddingTop = titleDom.clientHeight+'px';
            }
            var curDom = document.getElementById('DiscussSecondVirtualList');
            if(curDom) {
                curDom.style.height = height+'px';
            }
            this.itemComponent = this.secondLunpanTab == 1 ? DiscussDeleteItem : DiscussMainItem;
        },
        onScrollToBottom() {
            // 下拉加载更新列表数据
            if(this.secondLunpanTab == 1) {
                this.$store.dispatch('discuss/initMySavedLunPanList', {
                    update: true
                });
            }else if(this.secondLunpanTab == 2) {
                this.$store.dispatch('discuss/initMyJoinedLunPanList', {
                    update: true
                })
            }
        }
    }
}
</script>